import { createSlice } from '@reduxjs/toolkit'
const manageRP_Slice = createSlice({
  name: 'manageRP_Reducer',
  initialState: {
    // custom mean
    customMeanLoading: false,
    customMeanData: null,
    customMeanError: null,
    clearCustomMeanResponse: null,

    postCustomMeanLoading: false,
    postCustomMeanData: null,
    postCustomMeanError: null,

    // input form list
    inputFormListLoading: false,
    inputFormListData: null,
    inputFormListError: null,

    // post input form list
    postInputFormListLoading: false,
    postInputFormListData: null,
    postInputFormListError: null,

    // create form
    createFormLoading: false,
    createFormData: null,
    createFormError: null,

    postCreateFormLoading: false,
    postCreateFormData: null,
    postCreateFormError: null,
    postCreateFormMessage:null,

    // exam session
    examSessionLoading: false,
    examSessionData: null,
    examSessionError: null,

    postExamSessionLoading: false,
    postExamSessionData: null,
    postExamSessionError: null,
    message: null,

    // tools dropdown
    toolsDropdownLoading: false,
    toolsDropdownData: null,
    toolsDropdownError: null,

    // year dropdown
    yearLoading: false,
    yearData: null,
    yearError: null,

    // email dropdown
    emailLoading: false,
    emailData: null,
    emailError: null,

    // device type dropdown
    deviceTypeLoading: false,
    deviceTypeData: null,
    deviceTypeError: null,

    // input flow type dropdown
    inputFlowTypeLoading: false,
    inputFlowTypeData: null,
    inputFlowTypeError: null,

    // shift dropdown
    shiftLoading: false,
    shiftData: null,
    shiftError: null,

    // difficulty dropdown
    difficultyLoading: false,
    difficultyData: null,
    difficultyError: null,

    // category dropdown
    categoryLoading: false,
    categoryData: null,
    categoryError: null,

    // disability dropdown
    disabilityLoading: false,
    disabilityData: null,
    disabilityError: null,

    // studentType dropdown
    studentTypeLoading: false,
    studentTypeData: null,
    studentTypeError: null,

    // input/result type dropdown
    typeLoading: false,
    typeData: null,
    typeError: null,

    //input/result process_type dropdown
    processTypeLoading: false,
    processTypeData: null,
    processTypeError: null,

    //merit list
    meritListLoading: false,
    meritListData: null,
    meritListError: null,
    // mappedProcessType Dropdown
    mappedProcessTypeLoading: false,
    mappedProcessTypeData: null,
    mappedProcessTypeError: null,
  
    // input process type Dropdown
    inputProcessTypeLoading: false,
    inputProcessTypeData: null,
    inputProcessTypeError: null,

    // post merit list
    postMeritListLoading: false,
    postMeritListData: null,
    postMeritListError: null,

    // merit list validation check
    postMeritListValidationCheckLoading: false,
    postMeritListValidationCheckData: null,
    postMeritListValidationCheckError: null,
    postMeritListValidationMessage: null,

    // upload merit list
    postUploadMeriListLoading: false,
    postUploadMeriListData: null,
    postUploadMeriListError: null,

    // detail input/result flow api
    detailFlowTypeLoading: false,
    detailFlowTypeData: null,
    detailFlowTypeError: null,

    // post appeared students
    postAppearedStudentsLoading: false,
    postAppearedStudentsData: null,
    postAppearedStudentsError: null,

    // Variation Factor
    VariationFactorLoading: false,
    VariationFactorData: null,
    VariationFactorError: null,

    postVariationFactorLoading: false,
    postVariationFactorData: null,
    postVariationFactorError: null,

    message: "",

    toolsName: {
      loading: false,
      data: [],
      error: null,
    },
    resultFlowType: {
      loading: false,
      data: [],
      error: null,
    },
    presetType: {
      loading: false,
      data: [],
      error: null,
    },

    //usage report
    usageListLoading: false,
    usageListData: null,
    usageListError: null,

    usageAnalyticsLoading: false,
    usageAnalyticsData: null,
    usageAnalyticsError: null,

    // field type
    fieldTypeLoading: false,
    fieldTypeData: null,
    fieldTypeError: null,

    // create form add.edit
    createFormDetailLoading: false,
    createFormDetailData: null,
    createFormDetailError: null,

    postCreateFormDetailDataLoading: false,
    postCreateFormDetailData: null,
    postCreateFormDetailError: null,
    postCreateFormDetailMessageError: null,
    postCreateFormDetailMessage:null,

    // mappedCategory Dropdown
    mappedCategoryLoading: false,
    mappedCategoryData: null,
    mappedCategoryError: null,

  },
  reducers: {
    // common dropdown
    getCommonDropdownLoading(state, action) {
      return {
        ...state,
        commonDropdownLoading: true,
      }
    },
    getCommonDropdownSuccess(state, action) {
      return {
        ...state,
        commonDropdownLoading: false,
        commonDropdownData: action.payload,
      }
    },
    getCommonDropdownFailure(state, action) {
      return {
        ...state,
        commonDropdownLoading: false,
        commonDropdownError: action.payload,
      }
    },
    getCommonDropdownClear(state, action) {
      return {
        ...state,
        commonDropdownData: null,
      }
    },
    getVariationFactorLoading(state, action) {
      return {
        ...state,
        VariationFactorLoading: true,
      }
    },
    getVariationFactorSuccess(state, action) {
      return {
        ...state,
        VariationFactorLoading: false,
        variationFactorData: action.payload,
      }
    },
    getVariationFactorFailure(state, action) {
      return {
        ...state,
        VariationFactorLoading: false,
        VariationFactorError: action.payload,
      }
    },
    postVariationFactorLoading(state, action) {
      return {
        ...state,
        postVariationFactorLoading: true,
      }
    },
    postVariationFactorSuccess(state, action) {
      return {
        ...state,
        postVariationFactorLoading: false,
        postVariationFactorData: action.payload,
        message: action.payload
      }
    },
    postVariationFactorFailure(state, action) {
      return {
        ...state,
        postVariationFactorLoading: false,
        postVariationFactorError: action.payload,
        message: action.payload
      }
    },

    postVariationFactorclear(state, action) {
      return {
        ...state,
        postVariationFactorData: null,
        postVariationFactorError: null,
      }
    },

    // common params
    // Actions for tools_name
    fetchToolsNameLoading(state) {
      state.toolsName.loading = true
    },
    fetchToolsNameSuccess(state, action) {
      state.toolsName.loading = false
      state.toolsName.data = action.payload
    },
    fetchToolsNameFailure(state, action) {
      state.toolsName.loading = false
      state.toolsName.error = action.payload
    },

    // Actions for result_flow_type
    fetchResultFlowTypeLoading(state) {
      state.resultFlowType.loading = true
    },
    fetchResultFlowTypeSuccess(state, action) {
      state.resultFlowType.loading = false
      state.resultFlowType.data = action.payload
    },
    fetchResultFlowTypeFailure(state, action) {
      state.resultFlowType.loading = false
      state.resultFlowType.error = action.payload
    },

    // Actions for preset_type
    fetchPresetTypeLoading(state) {
      state.presetType.loading = true
    },
    fetchPresetTypeSuccess(state, action) {
      state.presetType.loading = false
      state.presetType.data = action.payload
    },
    fetchPresetTypeFailure(state, action) {
      state.presetType.loading = false
      state.presetType.error = action.payload
    },

    // custom mean
    getCustomMeanLoading(state, action) {
      return {
        ...state,
        customMeanLoading: true,
      }
    },
    getCustomMeanSuccess(state, action) {
      return {
        ...state,
        customMeanLoading: false,
        customMeanData: action.payload,
      }
    },
    getCustomMeanFailure(state, action) {
      return {
        ...state,
        customMeanLoading: false,
        customMeanError: action.payload,
      }
    },
    postCustomMeanLoading(state, action) {
      return {
        ...state,
        postCustomMeanLoading: true,
      }
    },
    postCustomMeanSuccess(state, action) {
      return {
        ...state,
        postCustomMeanLoading: false,
        postCustomMeanData: action.payload,
      }
    },
    postCustomMeanFailure(state, action) {
      return {
        ...state,
        postCustomMeanLoading: false,
        postCustomMeanError: action.payload,
      }
    },
    clearCustomMeanResponse(state, action) {
      return {
        ...state,
        postCustomMeanData: null,
        postCustomMeanError: null,
        customMeanData: null,
      }
    },
    // input form list
    getInputFormListLoading(state, action) {
      return {
        ...state,
        inputFormListLoading: true,
      }
    },
    getInputFormListSuccess(state, action) {
      return {
        ...state,
        inputFormListLoading: false,
        inputFormListData: action.payload,
      }
    },
    getInputFormListFailure(state, action) {
      return {
        ...state,
        inputFormListLoading: false,
        inputFormListError: action.payload,
      }
    },

    // post input form API
    postInputFormListLoading(state, action) {
      return {
        ...state,
        postInputFormListLoading: true,
      }
    },
    postInputFormListSuccess(state, action) {
      return {
        ...state,
        postInputFormListLoading: false,
        postInputFormListData: action.payload,
      }
    },
    postInputFormListFailure(state, action) {
      return {
        ...state,
        postInputFormListLoading: false,
        postInputFormListError: action.payload,
      }
    },
    clearPostInputFormListResponse(state, action) {
      return {
        ...state,
        postInputFormListData: null,
        postInputFormListError: null,
      }
    },
    // create form
    getCreateFormLoading(state, action) {
      return {
        ...state,
        createFormLoading: true,
      }
    },
    getCreateFormSucess(state, action) {
      return {
        ...state,
        createFormLoading: false,
        createFormData: action.payload,
      }
    },
    getCreateFormFailure(state, action) {
      return {
        ...state,
        createFormLoading: false,
        createFormError: action.payload,
      }
    },
    postCreateFormLoading(state, action) {
      return {
        ...state,
        postCreateFormLoading: true,
      }
    },
    postCreateFormSucess(state, action) {
      return {
        ...state,
        postCreateFormLoading: false,
        postCreateFormData: action.payload,
        postCreateFormMessage:"Data Added Successfully"
      }
    },
    postCreateFormFailure(state, action) {
      return {
        ...state,
        postCreateFormLoading: false,
        postCreateFormError: action.payload,
        postCreateFormMessage:"Something went wrong"
        
      }
    },
    postCreateFormSuccessResponse(state, action) {
      return {
        ...state,
        postCreateFormData: null,
        postCreateFormMessage:null,
      }
    },
    // exam session
    getExamSessionLoading(state, action) {
      return {
        ...state,
        examSessionLoading: true,
      }
    },
    getExamSessionSuccess(state, action) {
      return {
        ...state,
        examSessionLoading: false,
        examSessionData: action.payload,
      }
    },
    getExamSessionFailure(state, action) {
      return {
        ...state,
        examSessionLoading: false,
        examSessionError: action.payload,
      }
    },
    clearExamSessionSuccess(state, action) {
      return {
        ...state,
        examSessionData: null,
        examSessionError: null,
      }
    },
    postExamSessionLoading(state, action) {
      return {
        ...state,
        postExamSessionLoading: true,
      }
    },
    postExamSessionSuccess(state, action) {
      return {
        ...state,
        postExamSessionLoading: false,
        postExamSessionData: action.payload,
        message: 'Session Saved Successfully',
      }
    },
    postExamSessionFailure(state, action) {
      return {
        ...state,
        postExamSessionLoading: false,
        postExamSessionError: action.payload,
        message: 'Something went wrong',
      }
    },
    clearMessage(state, action) {
      return {
        ...state,
        message: null,
      }
    },
    // tools dropdown
    getToolsDropdownLoading(state, action) {
      return {
        ...state,
        toolsDropdownLoading: true,
      }
    },
    getToolsDropdownSuccess(state, action) {
      return {
        ...state,
        toolsDropdownLoading: false,
        toolsDropdownData: action.payload,
      }
    },
    getToolsDropdownFailure(state, action) {
      return {
        ...state,
        toolsDropdownLoading: false,
        toolsDropdownError: action.payload,
      }
    },
    clearToolsDropdownSuccessResponse(state, action) {
      return {
        ...state,
        toolsDropdownData: null,
      }
    },
    // year dropdown
    getYearLoading(state, action) {
      return {
        ...state,
        yearLoading: true,
      }
    },
    getYearSuccess(state, action) {
      return {
        ...state,
        yearLoading: false,
        yearData: action.payload,
      }
    },
    getYearFailure(state, action) {
      return {
        ...state,
        yearLoading: false,
        yearError: action.payload,
      }
    },
    // email dropdown
    getEmailLoading(state, action) {
      return {
        ...state,
        emailLoading: true,
      }
    },
    getEmailSuccess(state, action) {
      return {
        ...state,
        emailLoading: false,
        emailData: action.payload,
      }
    },
    getEmailFailure(state, action) {
      return {
        ...state,
        emailLoading: false,
        emailError: action.payload,
      }
    },

    // device type dropdown
    getDeviceTypeLoading(state, action) {
      return {
        ...state,
        deviceTypeLoading: true,
      }
    },
    getDeviceTypeSuccess(state, action) {
      return {
        ...state,
        deviceTypeLoading: false,
        deviceTypeData: action.payload,
      }
    },
    getDeviceTypeFailure(state, action) {
      return {
        ...state,
        deviceTypeLoading: false,
        deviceTypeError: action.payload,
      }
    },

    // input flow type dropdown
    getInputFlowTypeLoading(state, action) {
      return {
        ...state,
        inputFlowTypeLoading: true,
      }
    },
    getInputFlowTypeSuccess(state, action) {
      return {
        ...state,
        inputFlowTypeLoading: false,
        inputFlowTypeData: action.payload,
      }
    },
    getInputFlowTypeFailure(state, action) {
      return {
        ...state,
        inputFlowTypeLoading: false,
        inputFlowTypeError: action.payload,
      }
    },
    // shift dropdown
    getShiftLoading(state, action) {
      return {
        ...state,
        shiftLoading: true,
      }
    },
    getShiftSuccess(state, action) {
      return {
        ...state,
        shiftLoading: false,
        shiftData: action.payload,
      }
    },
    getShiftFailure(state, action) {
      return {
        ...state,
        shiftLoading: false,
        shiftError: action.payload,
      }
    },

    // difficulty dropdown
    getDifficultyLoading(state, action) {
      return {
        ...state,
        difficultyLoading: true,
      }
    },
    getDifficultySuccess(state, action) {
      return {
        ...state,
        difficultyLoading: false,
        difficultyData: action.payload,
      }
    },
    getDifficultyFailure(state, action) {
      return {
        ...state,
        difficultyLoading: false,
        difficultyError: action.payload,
      }
    },

    // category dropdown
    getCategoryLoading(state, action) {
      return {
        ...state,
        categoryLoading: true,
      }
    },
    getCategorySuccess(state, action) {
      return {
        ...state,
        categoryLoading: false,
        categoryData: action.payload,
      }
    },
    getCategoryFailure(state, action) {
      return {
        ...state,
        categoryLoading: false,
        categoryError: action.payload,
      }
    },

    // disability
    getDisabilityLoading(state, action) {
      return {
        ...state,
        disabilityLoading: true,
      }
    },
    getDisabilitySuccess(state, action) {
      return {
        ...state,
        disabilityLoading: false,
        disabilityData: action.payload,
      }
    },
    getDisabilityFailure(state, action) {
      return {
        ...state,
        disabilityLoading: false,
        disabilityError: action.payload,
      }
    },

    // exam type
    getStudentTypeLoading(state, action) {
      return {
        ...state,
        studentTypeLoading: true,
      }
    },
    getStudentTypeSuccess(state, action) {
      return {
        ...state,
        studentTypeLoading: false,
        studentTypeData: action.payload,
      }
    },
    getStudentTypeFailure(state, action) {
      return {
        ...state,
        studentTypeLoading: false,
        studentTypeError: action.payload,
      }
    },

    // input/result type dropdown
    getTypeLoading(state, action) {
      return {
        ...state,
        typeLoading: true,
      }
    },
    getTypeSuccess(state, action) {
      return {
        ...state,
        typeLoading: false,
        typeData: action.payload,
      }
    },
    getTypeFailure(state, action) {
      return {
        ...state,
        typeLoading: false,
        typeError: action.payload,
      }
    },
    // process type dropdown
    getProcessTypeLoading(state, action) {
      return {
        ...state,
        processTypeLoading: true,
      }
    },
    getProcessTypeSuccess(state, action) {
      return {
        ...state,
        processTypeLoading: false,
        processTypeData: action.payload,
      }
    },
    getProcessTypeFailure(state, action) {
      return {
        ...state,
        processTypeLoading: false,
        processTypeError: action.payload,
      }
    },

    // appeared students
    appearedStudentsLoading(state, action) {
      return {
        ...state,
        appearedStudentsLoading: true,
      }
    },
    appearedStudentsSuccess(state, action) {
      return {
        ...state,
        appearedStudentsLoading: false,
        appearedStudentsData: action.payload,
      }
    },
    appearedStudentsFailure(state, action) {
      return {
        ...state,
        appearedStudentsLoading: false,
        appearedStudentsError: action.payload,
      }
    },

    postAppearedStudentsLoading(state, action) {
      return {
        ...state,
        postAppearedStudentsLoading: true,
      }
    },
    postAppearedStudentsSuccess(state, action) {
      return {
        ...state,
        postAppearedStudentsLoading: false,
        postAppearedStudentsData: action.payload,
        message:"Data saved successfully!"
      }
    },
    postAppearedStudentsFailure(state, action) {
      return {
        ...state,
        postAppearedStudentsLoading: false,
        postAppearedStudentsError: action.payload,
        message:action.payload,

      }
    },
    postAppearedStudentClear(state, action) {
      return {
        ...state,
        postAppearedStudentsData: null,
        postAppearedStudentsError: null,
        message:null,
      }
    },

    // merit list
    getMeritListLoading(state, action) {
      return {
        ...state,
        meritListLoading: true,
      }
    },
    getMeritListSuccess(state, action) {
      return {
        ...state,
        meritListLoading: false,
        meritListData: action.payload,
      }
    },
    getMeritListFailure(state, action) {
      return {
        ...state,
        meritListLoading: false,
        meritListError: action.payload,
      }
    },

    // mapped process type
    getMappedProcessTypeLoading(state, action) {
      return {
        ...state,
        mappedProcessTypeLoading: true,
      }
    },
    getMappedProcessTypeSuccess(state, action) {
      return {
        ...state,
        mappedProcessTypeLoading: false,
        mappedProcessTypeData: action.payload,
      }
    },
    getMappedProcessTypeFailure(state, action) {
      return {
        ...state,
        mappedProcessTypeLoading: false,
        mappedProcessTypeError: action.payload,
      }
    },



    // inputprocess type 
    getInputProcessTypeLoading(state, action) {
      return {
        ...state,
        inputProcessTypeLoading: true,
      }
    },
    getInputProcessTypeSuccess(state, action) {
      return {
        ...state,
        inputProcessTypeLoading: false,
        inputProcessTypeData: action.payload,
      }
    },
    getInputProcessTypeFailure(state, action) {
      return {
        ...state,
        inputProcessTypeLoading: false,
        inputProcessTypeError: action.payload,
      }
    },


    clearMeritListSuccessResponse(state, action) {
      return {
        ...state,
        meritListData: null,
        meritListError: null,
      }
    },
    //post merit list
    postMeritListLoading(state, action) {
      return {
        ...state,
        postMeritListLoading: true,
      }
    },
    postMeritListSuccess(state, action) {
      return {
        ...state,
        postMeritListLoading: false,
        postMeritListData: action.payload,
      }
    },
    postMeritListFailure(state, action) {
      return {
        ...state,
        postMeritListLoading: false,
        postMeritListError: action.payload,
      }
    },
    clearPostMeritListResponse(state, action) {
      return {
        ...state,
        postMeritListData: null,
        postMeritListError: null,
      }
    },

    // merit list validation
    postMeritListValidationCheckLoading(state, action) {
      return {
        ...state,
        postMeritListValidationCheckLoading: true,
      }
    },
    postMeritListValidationCheckSuccess(state, action) {
      return {
        ...state,
        postMeritListValidationCheckLoading: false,
        postMeritListValidationCheckData: action.payload,
        postMeritListValidationMessage: 'Merit list uploaded.',
      }
    },
    postMeritListValidationCheckFailure(state, action) {
      return {
        ...state,
        postMeritListValidationCheckLoading: false,
        postMeritListValidationCheckError: action.payload,
      }
    },
    clearPostMeritListValidationCheckResponse(state, action) {
      return {
        ...state,
        postMeritListValidationCheckData: null,
        postMeritListValidationCheckLoading: false,
        postMeritListValidationCheckError: null,
        postMeritListValidationMessage: null,
      }
    },
    clearPostMeritListValidationMessageCheckResponse(state, action) {
      return {
        ...state,
        postMeritListValidationCheckError: null,
      }

    },
    clearPostMeritListMessageResponse(state, action) {
      return {
        ...state,
        postMeritListValidationMessage: null,
      }
    },

    // upload merit list
    postUploadMeriListLoading(state, action) {
      return {
        ...state,
        postUploadMeriListLoading: true,
      }
    },
    postUploadMeritListSuccess(state, action) {
      return {
        ...state,
        postUploadMeriListLoading: false,
        postUploadMeriListData: action.payload,
      }
    },
    postUploadMeriListFailure(state, action) {
      return {
        ...state,
        postUploadMeriListLoading: false,
        postUploadMeriListError: action.payload,
      }
    },
    clearPostUploadMeriListResponse(state, action) {
      return {
        ...state,
        postUploadMeriListData: null,
        postUploadMeriListError: null,
      }
    },
    // detail flow type
    getDetailFlowTypeLoading(state, action) {
      return {
        ...state,
        detailFlowTypeLoading: true,
      }
    },
    getDetailFlowTypeSuccess(state, action) {
      return {
        ...state,
        detailFlowTypeLoading: false,
        detailFlowTypeData: action.payload,
      }
    },
    getDetailFlowTypeFailure(state, action) {
      return {
        ...state,
        detailFlowTypeLoading: false,
        detailFlowTypeError: action.payload,
      }
    },
    getDetailFlowTypeClearData(state, action) {
      return {
        ...state,
        detailFlowTypeData: null,
      }
    },

    //rp usage report
    //usage list
    getUsageListLoading(state, action) {
      return {
        ...state,
        usageListLoading: true,
      }
    },
    getUsageListSuccess(state, action) {
      return {
        ...state,
        usageListLoading: false,
        usageListData: action.payload,
      }
    },
    getUsageListFailure(state, action) {
      return {
        ...state,
        usageListLoading: false,
        usageListError: action.payload,
      }
    },
    clearUsageListResponse(state, action) {
      return {
        ...state,
        usageListData: null,
      }
    },

    //usage analytics
    getUsageAnalyticsLoading(state, action) {
      return {
        ...state,
        usageAnalyticsLoading: true,
      }
    },
    getUsageAnalyticsSuccess(state, action) {
      return {
        ...state,
        usageAnalyticsLoading: false,
        usageAnalyticsData: action.payload,
      }
    },
    getUsageAnalyticsFailure(state, action) {
      return {
        ...state,
        usageAnalyticsLoading: false,
        usageAnalyticsError: action.payload,
      }
    },
    clearUsageAnalyticsResponse(state, action) {
      return {
        ...state,
        usageListData: null,
      }
    },
    getFieldTypeLoading(state, action) {
      return {
        ...state,
        fieldTypeLoading: true,
      }
    },
    getFieldTypeSuccess(state, action) {
      return {
        ...state,
        fieldTypeLoading: false,
        fieldTypeData: action.payload,
      }
    },
    getFieldTypeFailure(state, action) {
      return {
        ...state,
        fieldTypeLoading: false,
        fieldTypeError: action.payload,
      }
    },
    clearFieldTypeSuccessResponse(state, action) {
      return {
        ...state,
        fieldTypeData: null,
      }
    },

    // create form add.edit
    getCreateFormDetailLoading(state, action) {
      return {
        ...state,
        createFormDetailLoading: true,
      }
    },
    getCreateFormDetailSuccess(state, action) {
      return {
        ...state,
        createFormDetailLoading: false,
        createFormDetailData: action.payload,
      }
    },
    getCreateFormDetailFailure(state, action) {
      return {
        ...state,
        createFormDetailLoading: false,
        createFormDetailError: action.payload,
      }
    },
    clearCreateFormDetailSuccessResponse(state, action) {
      return {
        ...state,
        createFormDetailData: null,
      }
    },



    postCreateFormDetailLoading(state, action) {
      return {
        ...state,
        postCreateFormDetailDataLoading: true,
      }
    },
    postCreateFormDetailSuccess(state, action) {
      return {
        ...state,
        postCreateFormDetailDataLoading: false,
        postCreateFormDetailData: action.payload,
        postCreateFormDetailMessage:"Data Added Successfully",
      }
    },
    postCreateFormDetailFailure(state, action) {
      return {
        ...state,
        postCreateFormDetailDataLoading: false,
        postCreateFormDetailError: action.payload,
        postCreateFormDetailMessage:"Something Went Wrong",
      }
    },
    postCreateFormDetailMessageFailure(state, action) {
      return {
        ...state,
        postCreateFormDetailDataLoading: false,
        postCreateFormDetailMessageError: action.payload,
        postCreateFormDetailMessage:"Something Went Wrong",
      }
    },
    clearPostCreateFormDetailSuccessResponse(state, action) {
      return {
        ...state,
        postCreateFormDetailData: null,
        postCreateFormDetailMessage:null,
      }
    },
    clearPostCreateFormDetailMessageResponse(state, action) {
      return {
        ...state,
        postCreateFormDetailError:null,
        postCreateFormDetailMessageError:null,
      }
    },
  
    getMappedCategoryDataLoading(state, action) {
      return {
        ...state,
        mappedCategoryLoading: true,
      }
    },
    getMappedCategoryDataSuccess(state, action) {
      return {
        ...state,
        mappedCategoryLoading: false,
        mappedCategoryData: action.payload,
      }
    },
    getMappedCategoryDataFailure(state, action) {
      return {
        ...state,
        mappedCategoryLoading: false,
        mappedCategoryError: action.payload,
      }
    },
    clearMappedCategoryDataResponse(state, action) {
      return {
        ...state,
        mappedCategoryData: null,
      }
    },
  },
})
export const {
  getCommonDropdownLoading,
  getCommonDropdownSuccess,
  getCommonDropdownFailure,
  getCommonDropdownClear,

  getCustomMeanLoading,
  getCustomMeanSuccess,
  getCustomMeanFailure,

  postCustomMeanLoading,
  postCustomMeanSuccess,
  postCustomMeanFailure,
  clearCustomMeanResponse,

  getInputFormListLoading,
  getInputFormListSuccess,
  getInputFormListFailure,

  postInputFormListLoading,
  postInputFormListSuccess,
  postInputFormListFailure,
  clearPostInputFormListResponse,

  getCreateFormLoading,
  getCreateFormSucess,
  getCreateFormFailure,

  postCreateFormLoading,
  postCreateFormSucess,
  postCreateFormFailure,
  postCreateFormSuccessResponse,

  getExamSessionLoading,
  getExamSessionSuccess,
  getExamSessionFailure,

  postExamSessionLoading,
  postExamSessionSuccess,
  postExamSessionFailure,
  clearExamSessionSuccess,

  getToolsDropdownLoading,
  getToolsDropdownSuccess,
  getToolsDropdownFailure,
  clearToolsDropdownSuccessResponse,

  getYearLoading,
  getYearSuccess,
  getYearFailure,

  getEmailLoading,
  getEmailSuccess,
  getEmailFailure,

  getDeviceTypeLoading,
  getDeviceTypeSuccess,
  getDeviceTypeFailure,


  getCategoryLoading,
  getCategorySuccess,
  getCategoryFailure,

  getDisabilityLoading,
  getDisabilitySuccess,
  getDisabilityFailure,

  getStudentTypeLoading,
  getStudentTypeSuccess,
  getStudentTypeFailure,

  getInputFlowTypeLoading,
  getInputFlowTypeSuccess,
  getInputFlowTypeFailure,

  getShiftLoading,
  getShiftSuccess,
  getShiftFailure,

  getDifficultyLoading,
  getDifficultySuccess,
  getDifficultyFailure,

  getTypeLoading,
  getTypeSuccess,
  getTypeFailure,

  getProcessTypeLoading,
  getProcessTypeSuccess,
  getProcessTypeFailure,

  appearedStudentsLoading,
  appearedStudentsSuccess,
  appearedStudentsFailure,

  postAppearedStudentsLoading,
  postAppearedStudentsSuccess,
  postAppearedStudentsFailure,
  postAppearedStudentClear,

  clearMessage,

  getMeritListLoading,
  getMeritListSuccess,
  getMeritListFailure,
  clearMeritListSuccessResponse,

  getMappedProcessTypeFailure,
  getMappedProcessTypeLoading,
  getMappedProcessTypeSuccess,

  getInputProcessTypeFailure,
  getInputProcessTypeLoading,
  getInputProcessTypeSuccess,

  postMeritListLoading,
  postMeritListSuccess,
  postMeritListFailure,
  clearPostMeritListResponse,

  postMeritListValidationCheckLoading,
  postMeritListValidationCheckSuccess,
  postMeritListValidationCheckFailure,
  clearPostMeritListValidationCheckResponse,

  postUploadMeriListLoading,
  postUploadMeritListSuccess,
  postUploadMeriListFailure,
  clearPostUploadMeriListResponse,

  getDetailFlowTypeLoading,
  getDetailFlowTypeSuccess,
  getDetailFlowTypeFailure,
  getDetailFlowTypeClearData,
  clearPostMeritListMessageResponse,

  getVariationFactorLoading,
  getVariationFactorSuccess,
  getVariationFactorFailure,

  postVariationFactorLoading,
  postVariationFactorSuccess,
  postVariationFactorFailure,
  postVariationFactorclear,

  // common params

  fetchToolsNameLoading,
  fetchToolsNameSuccess,
  fetchToolsNameFailure,
  fetchResultFlowTypeLoading,
  fetchResultFlowTypeSuccess,
  fetchResultFlowTypeFailure,
  fetchPresetTypeLoading,
  fetchPresetTypeSuccess,
  fetchPresetTypeFailure,

  clearPostMeritListValidationMessageCheckResponse,
  // rp usage panel
  getUsageListLoading,
  getUsageListSuccess,
  getUsageListFailure,
  clearUsageListResponse,
  getUsageAnalyticsLoading,
  getUsageAnalyticsSuccess,
  getUsageAnalyticsFailure,
  clearUsageAnalyticsResponse,

  getFieldTypeLoading,
  getFieldTypeSuccess,
  getFieldTypeFailure,
  clearFieldTypeSuccessResponse,


  //create form add/edit
  getCreateFormDetailLoading,
  getCreateFormDetailSuccess,
  getCreateFormDetailFailure,
  clearCreateFormDetailSuccessResponse,

  postCreateFormDetailLoading,
  postCreateFormDetailSuccess,
  postCreateFormDetailFailure,
  clearPostCreateFormDetailSuccessResponse,
  clearPostCreateFormDetailMessageResponse,
  postCreateFormDetailMessageFailure,

  getMappedCategoryDataLoading,
  getMappedCategoryDataSuccess,
  getMappedCategoryDataFailure,
  clearMappedCategoryDataResponse,

} = manageRP_Slice.actions
export default manageRP_Slice.reducer
